import { ref, reactive } from 'virtual-vue';
import zhCNMessages from './lang/zh-cn';
import zhHKMessages from './lang/zh-hk';
import enMessages from './lang/en';
import { deepAssign } from '../utils/deep-assign';

type Message = Record<string, any>;
type Messages = Record<string, Message>;

/** 内置语言包 */
const internalLangMap = {
  'zh-cn': zhCNMessages,
  'zh-hk': zhHKMessages,
  en: enMessages,
};
/** 当前语言 */
const lang = ref('zh-cn');
/** 文案映射 */
const messages = reactive<Messages>({
  'zh-cn': zhCNMessages,
});

export const Locale = {
  /** 获取当前语言下所有语言内容 */
  messages(): Message {
    return messages[lang.value];
  },
  /** 使用指定语言，'zh-cn'|'zh-hk'|'en' 无需传入语言包 */
  use(newLang: string, newMessages?: Message) {
    lang.value = newLang;
    const message = newMessages || internalLangMap[newLang];
    this.add({ [newLang]: message });
  },
  add(newMessages: Message = {}) {
    deepAssign(messages, newMessages);
  },
};

export const useCurrentLang = () => lang;

export default Locale;
